import React from 'react';

import { CardTitle } from '@swf/sports/components';

import type { EventTypeInfo } from '../../types';
import Tabs from '../Tabs/Tabs';

import styles from './SportsEventTypeInfo.scss';

interface Props {
  eventTypeInfo: EventTypeInfo;
}

const SportsEventTypeInfo: React.FC<Props> = ({ eventTypeInfo: { eventTypeName, tabs } }) => (
  <>
    <div className={styles.titleWrapper}>
      <CardTitle>{eventTypeName}</CardTitle>
    </div>

    <Tabs tabs={tabs} />
  </>
);

export default SportsEventTypeInfo;
